import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { AuthProvider } from "./AuthContext";
import { DesignVersionProvider } from "./DesignVersionContext";

const updateHeight = () => {
    const vh = window.innerHeight;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
};
updateHeight();
window.addEventListener("resize", updateHeight);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    // <React.StrictMode>
    <DesignVersionProvider>
        <AuthProvider>
            <App />
        </AuthProvider>
    </DesignVersionProvider>
    // </React.StrictMode>
);
